import React, { Props } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "auto",
      // overflow: 'hidden',
      width: "100vw",
    },
  })
);

export const FullscreenLayout = (props: Props<any>) => {
  const { children } = props;
  // const { t, i18n } = useTranslation();
  // const history = useHistory();
  // const context = useContext(Context);
  const classes = useStyles();
  const theme = useTheme();
  // const win: any = window;
  // const langDir = i18n.dir(win['lang'] as string);
  return <div className={classes.root}>{props.children}</div>;
};
